import { useEmailListMessageCompletedHandlers } from '../useEmailListMessageCompletedHandlers'
import { useEmailMessageCompletedRealtime } from '../useEmailMessageCompletedRealtime'

/**
 * List-surface variant of `useEmailMessageCompletedRealtime`: when a message
 * finishes sending, patch the matching row in place via the table's
 * `handleUpdateItem`, so its "Sending"/error badge updates without a full
 * reload. Matches thread rows by `payload.thread_uuid` and, in single-email
 * (no conversation view) listings, message rows by `payload.uuid`. Shared by
 * every email-thread listing (the common email list, the request Emails
 * tab, …).
 *
 * Falls back to `onReload` when the row's resulting state cannot be computed
 * locally (the thread-wide `last_error` after a success event), and once on
 * the initial subscribe when a loaded row is still pending — to catch
 * completions that landed before the subscription was ready.
 *
 * @param {{
 *   channel: string | null,
 *   enabled?: boolean,
 *   items: Array<object> | null,
 *   handleUpdateItem: (arg: { id: string, updates: object }) => void,
 *   onReload?: () => void,
 *   onResync?: () => void,
 * }} options
 */
export function useEmailListMessageCompletedRealtime({
  channel,
  enabled,
  handleUpdateItem,
  items,
  onReload,
  onResync,
}) {
  const { handleInitialSubscribe, handleMessageCompleted } =
    useEmailListMessageCompletedHandlers({ handleUpdateItem, items, onReload })

  useEmailMessageCompletedRealtime({
    channel,
    enabled,
    onInitialSubscribe: handleInitialSubscribe,
    onMessageCompleted: handleMessageCompleted,
    onResync,
  })
}
